/* eslint-disable react/no-array-index-key */
/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent } from '@formio/react';
import { Grid, Dropdown } from '../../../canvasComponents/index';
import { FormattedMessage, IntlProvider, injectIntl } from 'react-intl';
import { v4 } from 'uuid';
import { selectAllTheDamagedAreasOptions, pickARoomToTellUsAboutOptions, getTypelist } from './ComponentsOptions';
import CustomInteriorRoomsSettings from './CustomInteriorRooms.settingsForm';
import './CustomInteriorRooms.scss';
import getLocalParams from '../localizationCustoms';

const CustomInteriorRooms = class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      data: props.data,
      formErrors: props.formErrors,
    };
    this.errorHandler = this.errorHandler.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.setCheckboxValue = this.setCheckboxValue.bind(this);
    this.checked = this.checked.bind(this);
    this.addNewRoom = this.addNewRoom.bind(this);
    this.removeRoom = this.removeRoom.bind(this);
    this.showDynamicField = this.showDynamicField.bind(this);
    this.translateOptions = this.translateOptions.bind(this);
  }

  componentDidMount() {
    const { state: { value, data }, props: { onChange, form } } = this;

    form?.on('error', this.errorHandler);

    if (data.lossCause?.value === 'windHail' || data.lossCause?.value === 'water') {
      pickARoomToTellUsAboutOptions.splice(pickARoomToTellUsAboutOptions.length - 1, 0, {
        label: 'Unfinished basement/crawl space',
        selectedLabel: 'Unfinished basement/crawl space',
        value: 'unfinishedBasement',
      });
    }

    if (value === null || typeof value === 'undefined') {
      const newObject = { temporaryId: `tempId-${v4()}`, id: '', pickARoomToTellUsAbout: { value: '', review: { label: 'Room 1', typelist: getTypelist('room') } }, selectAllTheDamagedAreas: { selectedValues: [], review: { label: 'Damages', typelist: getTypelist('damagedAreas') } } };

      const errors = Array(1).fill({ selectAllTheDamagedAreas: false });

      this.setState({ value: { interiorRoomsInfo: [newObject] }, formErrors: errors }, () => {
        // eslint-disable-next-line react/destructuring-assignment
        onChange(this.state.value);
      });
    } else {
      const num = value.interiorRoomsInfo.length;
      const errors = Array(num).fill({ selectAllTheDamagedAreas: false });
      this.setState({ value, formErrors: errors }, () => {
        onChange(value);
      });
    }
  }

  handleChange(inputValue, index, name) {
    const { state: { value }, props: { onChange, intl } } = this;

    const newList = [...value.interiorRoomsInfo];
    newList[index][name] = { value: inputValue, review: { label: `${intl.formatMessage({ id: 'Room', defaultValue: 'Room' })} ${index + 1}`, typelist: getTypelist('room') } };

    this.setState({
      value: {
        interiorRoomsInfo: newList,
      },
    }, () => {
      // eslint-disable-next-line react/destructuring-assignment
      onChange(this.state.value);
    });
  }

  setCheckboxValue = (type, index, v) => {
    const { value, formErrors } = this.state || null;
    const { onChange } = this.props || null;

    if (value?.interiorRoomsInfo) {
      if (value.interiorRoomsInfo[index][type].selectedValues.includes(v)) {
        const newList = [...value.interiorRoomsInfo];
        newList[index][type].selectedValues = newList[index][type].selectedValues.filter((selectedValue) => selectedValue !== v);

        const errors = [...formErrors];

        if (errors.length > 0) {
          errors[index][type] = newList[index][type].selectedValues.length < 1; // show errors if unchecked option was the last one
        }

        this.setState({
          value: {
            interiorRoomsInfo: newList,
          },
          formErrors: errors,
        }, () => {
          // eslint-disable-next-line react/destructuring-assignment
          onChange(this.state.value);
        });
      } else {
        const newList = [...value.interiorRoomsInfo];
        newList[index][type].selectedValues = newList[index][type].selectedValues.length ? [...newList[index][type].selectedValues, v] : [v];

        const errors = [...formErrors];

        if (errors.length > 0) {
          errors[index][type] = newList[index][type].selectedValues.length < 1;
        }

        this.setState({
          value: {
            interiorRoomsInfo: newList,
          },
          formErrors: errors,
        }, () => {
          // eslint-disable-next-line react/destructuring-assignment
          onChange(this.state.value);
        });
      }
    }
  };

  checked = (type, index, v) => {
    const { value } = this.state;

    if (value?.interiorRoomsInfo[index][type]?.selectedValues?.length) {
      if (value.interiorRoomsInfo[index][type].selectedValues.includes(v)) { return true; }
    }
    return false;
  };

  addNewRoom = () => {
    const { state: { formErrors }, props: { onChange } } = this;
    const newObject = { temporaryId: `tempId-${v4()}`, id: '', pickARoomToTellUsAbout: { value: '', review: { label: 'Room', typelist: getTypelist('room') } }, selectAllTheDamagedAreas: { selectedValues: [], review: { label: 'Damages', typelist: getTypelist('damagedAreas') } } };

    const errors = formErrors?.length ? [...formErrors] : [];
    errors.push({ selectAllTheDamagedAreas: false });

    this.setState((prevState) => ({ value: { interiorRoomsInfo: [...prevState.value.interiorRoomsInfo, newObject] }, formErrors: errors,
    }), () => {
      // eslint-disable-next-line react/destructuring-assignment
      onChange(this.state.value);
    });
  };

  removeRoom = (index) => {
    const { state: { value, formErrors }, props: { onChange } } = this;
    const tempState = { ...value };
    const errors = formErrors?.length ? [...formErrors] : [];
    const newErrors = errors.filter((_, i) => i !== index);

    const updatedState = tempState.interiorRoomsInfo.filter((_, i) => i !== index);

    this.setState({ value: {
      interiorRoomsInfo: updatedState,
    },
    formErrors: newErrors,
    }, () => {
      // eslint-disable-next-line react/destructuring-assignment
      onChange(this.state.value);
    });
  };

  showDynamicField = (index) => {
    const { value } = this.state || null;
    if (value?.interiorRoomsInfo[index]?.pickARoomToTellUsAbout?.value && value?.interiorRoomsInfo[index]?.pickARoomToTellUsAbout?.value !== '') {
      return true;
    }
    return false;
  };

  translateOptions = (options) => {
    const { intl } = this.props;
    return options.map((opt) => ({
      value: opt.value,
      selectedLabel: intl.formatMessage({ id: `${opt.label}`, defaultValue: `${opt.label}` }),
      label: intl.formatMessage({ id: `${opt.label}`, defaultValue: `${opt.label}` }),
    }));
  };

  errorHandler = () => {
    const { value } = this.state;
    const errors = [];

    value?.interiorRoomsInfo.forEach((element) => {
      const selectAllTheDamagedAreas = element?.selectAllTheDamagedAreas.selectedValues.length < 1;
      errors.push({ selectAllTheDamagedAreas });
    });

    this.setState({ formErrors: errors });
  };

  render() {
    const { state: { value, formErrors }, props: { disabled, intl } } = this;
    return (
      value?.interiorRoomsInfo.length ? value?.interiorRoomsInfo.map((element, index) => (
        <div key={`interiorRooms_${index}`} className="interiorRooms">
          <Grid key={index}>
            <div style={{ display: 'flex', flexDirection: 'row', textAlign: 'center' }}>
              <h3 className="roomTitle">{intl.formatMessage({ id: 'Room', defaultValue: 'Room' })} {index + 1}</h3>
              {index > 0 ? (
                <button
                  type="button"
                  className="removeRoom"
                  onClick={() => this.removeRoom(index)}
                >
                  <FormattedMessage id="Remove" defaultMessage="Remove" />
                </button>
              ) : null}
            </div>
            <div className="question-margin">
              <label className="label-question">
                <FormattedMessage id="Pick a room to tell us about" defaultMessage="Pick a room to tell us about" />
              </label>
              <Dropdown
                primary
                style={{ marginBottom: '16px' }}
                options={this.translateOptions(pickARoomToTellUsAboutOptions)}
                value={element.pickARoomToTellUsAbout.value}
                onChange={(v) => this.handleChange(v, index, 'pickARoomToTellUsAbout')}
                disabled={disabled}
              />
            </div>
            {this.showDynamicField(index) ? (
              <div>
                <label className="label-question">
                  <FormattedMessage id="Select all the damaged areas" defaultMessage="Select all the damaged areas" />
                </label>
                <div className="interiorRooms-multiple-checkboxes--wrapper injuries-smaller-checkboxes">
                  {selectAllTheDamagedAreasOptions.map((checkboxIndex) => {
                    const mCheckboxId = `checkbox_${Math.random() * 0xffffffffffff}`;
                    return (
                      <div
                      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                        tabIndex="0"
                        aria-labelledby={checkboxIndex.value}
                        role="group"
                        id={`div_${mCheckboxId}`}
                        key={`div_key_${mCheckboxId}`}
                        className="interiorRooms-multiple-checkboxes--div"
                      >
                        <input
                          type="checkbox"
                          disabled={disabled}
                          id={mCheckboxId}
                          key={`key_${mCheckboxId}`}
                          className={`interiorRooms-multiple-checkboxes${!this.checked('selectAllTheDamagedAreas', index, checkboxIndex.value) ? '' : ' interiorRooms-multiple-checkboxes--checked'}`}
                          value={checkboxIndex.value}
                          onChange={(newValue) => this.setCheckboxValue('selectAllTheDamagedAreas', index, newValue.target.value)}
                          checked={this.checked('selectAllTheDamagedAreas', index, checkboxIndex.value)}
                        />
                        <label htmlFor={mCheckboxId}>{intl.formatMessage({ id: `${checkboxIndex.label}`, defaultValue: `${checkboxIndex.label}` })}</label>
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : null}
            {formErrors && formErrors?.length ? (formErrors[index]?.selectAllTheDamagedAreas || formErrors[index]?.pickARoomToTellUsAbout) && <div className="form-custom-errors"><FormattedMessage id="Oops! Looks like you forgot to fill this in." defaultMessage="Oops! Looks like you forgot to fill this in." /></div> : null}
            {index + 1 === value?.interiorRoomsInfo?.length ? (
              <button
                type="button"
                className="addNewRoom"
                onClick={() => this.addNewRoom()}
              ><FormattedMessage id="Add a room" defaultMessage="Add a room" />
              </button>
            ) : null}
          </Grid>
        </div>
      )) : null
    );
  }
};

const CustomInteriorRoomsWithIntl = injectIntl(CustomInteriorRooms);

export default class InteriorRoomsComp extends ReactComponent {
  /**
   * This function tells the form builder about your component. It's name, icon and what group it should be in.
   *
   * @returns {{title: string, icon: string, group: string, documentation: string, weight: number, schema: *}}
   */
  static get builderInfo() {
    return {
      title: 'Custom InteriorRooms',
      icon: 'tasks',
      group: 'data',
      documentation: '',
      schema: InteriorRoomsComp.schema(),
    };
  }

  /**
   * This function is the default settings for the component. At a minimum you want to set the type to the registered
   * type of your component (i.e. when you call Components.setComponent('type', MyComponent) these types should match.
   *
   * @param sources
   * @returns {*}
   */
  static schema(...extend) {
    return ReactComponent.schema(
      {
        type: 'customInteriorRooms',
      },
      extend,
    );
  }

  /*
   * Defines the settingsForm when editing a component in the builder.
   */
  static editForm = CustomInteriorRoomsSettings;

  /**
   * This function is called when the DIV has been rendered and added to the DOM. You can now instantiate the react component.
   *
   * @param DOMElement
   * #returns ReactInstance
   */
  attachReact(element) {
    let instance;
    const localParams = getLocalParams(this.i18next.language);
    ReactDOM.render(
      <IntlProvider locale={localParams?.lang} messages={localParams?.i18n}>
        <CustomInteriorRoomsWithIntl
          inputRef={(refer) => {
            instance = refer;
          }}
          disabled={this._disabled}
          component={this.component} // These are the component settings if you want to use them to render the component.
          value={this.dataValue || this.dataForSetting} // The starting value of the component.
          data={this.data}
          form={this.root?.parent}
          onChange={this.updateValue}
        />
      </IntlProvider>,
      element,
      // eslint-disable-next-line no-return-assign
      () => (this.reactInstance = instance),
    );
  }

  /**
   * Automatically detach any react components.
   *
   * @param element
   */
  // eslint-disable-next-line class-methods-use-this
  detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
